export const isValidDate = (value: string) => {
  const d = new Date(value);
  const dateArr = value.split("/");
  return d.getFullYear() === Number(dateArr[0]) && d.getMonth() === (Number(dateArr[1]) - 1) && d.getDate() === Number(dateArr[2]);
}
